module.exports = __webpack_public_path__ + "img/mcr1.6ead5d38.gif";